import type { GameSystemId } from '@roll1/shared';

/** Human-readable labels for game system badges and selectors */
export const GAME_SYSTEM_LABELS: Record<GameSystemId, string> = {
  dnd5e: 'D&D 5e',
  pf2e: 'PF2e',
  generic: 'Generic',
};
